import React, { useEffect, useState } from "react";
import {
  addSettlementAccount,
  getBanks,
  getCurrencies,
  verifyAccount,
} from "../../../services/settings";
import toast from "react-hot-toast";
import VerifyPopup from "./VerifyPopup";

const AddSettlement = ({ setAddSettle, setSettle }) => {
  const [banks, setBanks] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [currency, setCurrency] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [bvn, setBvn] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [currencyName, setCurrencyName] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchBanks = async () => {
    try {
      const res = await getBanks();
      setBanks(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const fetchCurrency = async () => {
    try {
      const res = await getCurrencies();
      setCurrency(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleBank = (e) => {
    setSelectedBank(e.target.value);
    const matchedBank = banks.find(
      (bank) => bank.id === parseInt(e.target.value)
    );
    const bankName = matchedBank ? matchedBank.name : "";
    setBankName(bankName);
    const matchedBankCode = banks.find(
      (bank) => bank.id === parseInt(e.target.value)
    );
    const bankCode = matchedBankCode ? matchedBank.code : "";
    setBankCode(bankCode);
  };

  const handleCountry = (e) => {
    setSelectedCountry(e.target.value);
  };

  const handleCurrency = (e) => {
    setSelectedCurrency(e.target.value);
    const matchedCurrency = currency.find(
      (cur) => cur.id === parseInt(e.target.value)
    );
    const currencyName = matchedCurrency ? matchedCurrency.name : "";
    setCurrencyName(currencyName);
  };

  const openModal = () => {
    setData({
      selectedCountry,
      currencyName,
      accountNumber,
      bankName,
      bvn,
      accountName,
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const toggleVerifyPopup = () => {
    console.log("Confirmed");
    closeModal();
  };

  const handleSubmit = async () => {
    try {
      const res = await addSettlementAccount({
        country: selectedCountry,
        currency: selectedCurrency,
        accountNumber: accountNumber,
        bankId: selectedBank,
        bvn: bvn,
        accountName: accountName,
      });
      toast.success(res.message);
      setAddSettle(false);
      setSettle(true);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleVerify = async (value) => {
    setLoading(true);
    try {
      const res = await verifyAccount({
        bankCode: bankCode,
        accountNumber: value,
      });
      setLoading(false);
      setAccountName(res.data.beneficiaryName);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        setAccountName("Account name not found");
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    // Ensure the value is numeric and has at most 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setAccountNumber(value);

      if (value.length === 10) {
        handleVerify(value);
      } else {
        // Clear the account name if input is not exactly 10 digits
        setAccountName("");
      }
    }
  };

  const cancelSettlement = () => {
    setAddSettle(false);
    setSettle(true);
  };

  useEffect(() => {
    fetchBanks();
    fetchCurrency();
  }, []);

  return (
    <div>
      <div className="relative h-[924px] overflow-hidden bg-red mt-8 rounded-[10px] xl:p-[3rem]">
        <div className="bg-white max-w-72 md:max-w-full h-[828px] rounded-[10px]">
          <div className="flex justify-between items-center text-primary font-[600] text-[20px] border border-gray-200 rounded-t-[10px] p-[1rem] pl-7">
            <div className="flex items-center gap-[120px] ">
              Add settlement account
            </div>
            <>
              <svg
                width="12"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.5 0.75L6 5.25L10.5 0.75"
                  stroke="#464255"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          </div>
          <section className="p-[1.8rem] w-[716px] h-[180px] mt-[1.5rem] grid xl:grid-cols-2 gap-x-[7rem] gap-5">
            <div>
              <label for="country">Country</label>
              <select
                className=" md:w-[348px] w-64 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
                name="country"
                id="country"
                value={selectedCountry}
                onChange={handleCountry}
              >
                <option value="">Select your option</option>
                <option value="Nigeria">Nigeria</option>
                <option value="Cote d'Ivoire">Cote d'Ivoire</option>
                <option value="Kenya">Kenya</option>
                <option value="Ghana">Ghana</option>
              </select>
            </div>
            <div>
              <label for="Bankname">Bank name</label>
              <select
                className=" md:w-[348px] w-64 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
                name="banks"
                id="banks"
                value={selectedBank}
                onChange={handleBank}
              >
                <option value="">Select bank</option>
                {banks.map((bank, index) => (
                  <option key={index} value={bank.id}>
                    {bank.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label for="currency">Account currency</label>
              <select
                className="md:w-[348px] w-64 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
                name="currency"
                id="currency"
                value={selectedCurrency}
                onChange={handleCurrency}
              >
                <option value="">Select currency </option>
                {currency.map((curr, index) => (
                  <option key={index} value={curr.id}>
                    {curr.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col">
              <label htmlFor="BVN">BVN</label>

              <input
                type="text"
                className="md:w-[348px] w-64 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] mt-3"
                value={bvn}
                onChange={(e) => setBvn(e.target.value)}
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="AcctNo">Account Number</label>
              <input
                type="text"
                className="md:w-[348px] w-64 h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] mt-3"
                // onChange={handleVerify}
                value={accountNumber}
                onChange={handleChange}
              />
              <p>{loading ? "Verifying..." : accountName}</p>
            </div>
          </section>
        </div>
        <div className="p-[1.8rem] absolute bottom-28 xl:bottom-80 w-[485px] flex flex-col items-start lg:items-center">
          <div>
            <label
              className="container"
              style={{
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              <div className="lg:text-[14px] w-60 lg:w-full font-[400] text-[#444444]">
                Make this my primary settlement account
              </div>
              <input type="checkbox" name="creditemails" />
              <span
                className="checkmark"
                style={{
                  marginTop: "2px",
                }}
              ></span>
            </label>
          </div>
          <div className="w-full flex gap-3 lg:gap-10">
            <button
              className="lg:w-[142px] w-28 text-primary border border-primary p-2 rounded-md"
              onClick={cancelSettlement}
            >
              Cancel
            </button>

            <button
              className="lg:w-[200px] w-28 bg-primary text-white p-2 rounded-md"
              // onClick={handleVerify}
              onClick={openModal}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      <VerifyPopup
        isOpen={showModal}
        onClose={closeModal}
        handleSubmit={handleSubmit}
        data={data}
      />
    </div>
  );
};

export default AddSettlement;
